import React, {Fragment, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {cmsService} from "../../utils/axios";
import phoneIcon from "../../assets/images/icons/contact-phone-icon.svg";
import emailIcon from "../../assets/images/icons/contact-email-icon.svg";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import backgroundImage from "../../assets/images/content/page-intro.png";
import ContactForm from "../../components/ContactForm/ContactForm";
import HomeNewsletter from "../HomePage/HomeNewsletter";
import analyitics from "../../utils/analytics";

function ContactPage(props) {

    const [page, setPage] = useState({
        Title: null,
        Content: null,
        BackgroundURL: null
    });

    const history = useHistory();

    useEffect(() => {
        cmsService.get("/ContactPage?URLSegment=kontakt&limit=1&add_fields=BackgroundURL").then(response => {
            let pageData = response.data.items[0];
            if (pageData !== undefined) {
                if (pageData.BackgroundURL == null) {
                    pageData.BackgroundURL = backgroundImage;
                }
                setPage(pageData);
                MetaTagsManipulator.setTitle(pageData.Title);
                MetaTagsManipulator.setDescription(pageData.MetaDescription);
            }
        }).catch(() => history.push("/"));
    }, []);

    const submitContactFormHandler = () => {
        analyitics.sendEvent({
            category: 'Podstrona Kontakt',
            action: 'Kliknięcie',
            label: 'Wyślij wiadomość',
            value: 1
        });
    };

    return (
        <Fragment>
            <section className="contact-page-section">
                <div className="container">

                    <div className="contact-page-breadcrumbs">
                        <span>go-auto.pl</span>
                        <span className="contact-page-breadcrumb-sep">›</span>
                        <span>Kontakt</span>
                    </div>

                    <h1 className="contact-page-h1">Kontakt</h1>

                    <div className="contact-page-grid">

                        <div className="contact-page-left">
                            {page.Content == null ? (
                                <p className="contact-page-loading">Ładowanie...</p>
                            ) : (
                                <div className="contact-page-desc"
                                     dangerouslySetInnerHTML={{__html: page.Content}}/>
                            )}

                            <div className="contact-page-contacts">
                                <div className="contact-page-contact-col">
                                    <span className="contact-page-contact-label">infolinia</span>
                                    <a href={"tel:" + props.seller.phone} className="contact-page-contact-link">
                                        <img src={phoneIcon} alt="" className="contact-page-contact-icon-img"/>
                                        <strong>{props.seller.phone}</strong>
                                    </a>
                                </div>
                                <div className="contact-page-contact-col">
                                    <span className="contact-page-contact-label">email</span>
                                    <a href={"mailto:" + props.seller.email} className="contact-page-contact-link">
                                        <img src={emailIcon} alt="" className="contact-page-contact-icon-img"/>
                                        <strong>{props.seller.email}</strong>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="contact-page-right">
                            <ContactForm onSuccess={submitContactFormHandler}/>
                        </div>

                    </div>
                </div>
            </section>

            <div className="contact-newsletter-wrapper">
                <HomeNewsletter/>
            </div>
        </Fragment>
    );
}

export default ContactPage;
